import CreateOrderModal from './CreateOrderModal';

export default CreateOrderModal;
